/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Steps, Step } from 'react-step-builder';
import { groupBy } from 'lodash';
import PropTypes from 'prop-types';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Navigation from './Navigation/Navigation';

const Form = ({ data, handleClose, services }) => {
  const config = {
    navigation: {
      component: (props) => <Navigation {...props} occupationId={data.occupation_id} techId={data.user_id} />,
      location: 'after'
    }
  };

  const validSkillset = services.filter((el) => el.job_sub_category_name);
  const byCategory = groupBy(validSkillset, (el) => el.job_sub_category_name);

  return (
    <Steps config={config}>
      <Step component={Step1} data={data} handleClose={handleClose} />
      <Step component={Step2} data={data} byCategory={byCategory} services={services} handleClose={handleClose} />
      <Step component={Step3} data={data} handleClose={handleClose} />
      <Step component={Step4} data={data} handleClose={handleClose} />
      <Step component={Step5} data={data} byCategory={byCategory} handleClose={handleClose} />
      <Step component={Step6} data={data} handleClose={handleClose} />
    </Steps>
  );
};

Form.propTypes = {
  data: PropTypes.shape({
    occupation_id: PropTypes.number,
    user_id: PropTypes.number,
  }),
  services: PropTypes.array,
  handleClose: PropTypes.func,
};

export default Form;
